import React from 'react';
import Layer from './Layer';
import { WHERE } from '../../util/enums/EnumLayers';
import ColumnTypeData from '../../util/ColumnType';
import AggregateColumn from '../../util/AggregateColumn';
import ColumnName from '../../util/ColumnName';
import ModalWhere from '../modals/ModalWhere';
import LayerWhereComponent from './LayerWhereComponent';
import { Operator } from '../../util/Operators';
import TableRef from '../../util/TableRef';

class LayerWhere extends Layer {
  readonly _clauses: LayerWhere[];

  private _isAnd?: boolean;

  constructor(
    readonly _lhs: AggregateColumn,
    readonly _operator: Operator,
    readonly _rhsValue: Nullable<string>,
    readonly _rhsColumn: Nullable<ColumnName>,
    readonly _expressionType: ColumnTypeData,
  ) {
    super(WHERE);
    this._clauses = [];
  }

  clauses() {
    return this._clauses;
  }

  isAnd(): boolean {
    return this._isAnd as boolean;
  }

  setIsAnd(isAnd?: boolean) {
    this._isAnd = isAnd;
  }

  static buildFromServer(layer: LayerWhere) {
    const buildClause = (l: LayerWhere) => {
      const rhsColumn = l._rhsColumn ? ColumnName.build(l._rhsColumn) : null;
      return new LayerWhere(
        AggregateColumn.build(l._lhs),
        l._operator,
        l._rhsValue,
        rhsColumn,
        ColumnTypeData.build(l._expressionType),
      );
    };
    // extract the first clause
    const result = buildClause(layer);
    // now extract all remaining clauses
    layer._clauses.forEach((c) => {
      result.clauses().push(buildClause(c));
    });
    result.setIsAnd(layer._isAnd);
    return result;
  }

  modal() {
    return ModalWhere;
  }

  lhs() {
    return this._lhs;
  }

  operator() {
    return this._operator;
  }

  rhsValue() {
    return this._rhsValue;
  }

  rhsColumn() {
    return this._rhsColumn;
  }

  expressionType() {
    return this._expressionType;
  }

  // @ts-expect-error: Infer a proper type.
  buildContent(
    editLayerClicked: () => void,
    aliases: Record<string, TableRef>,
    _isNewWorld: boolean,
    isNotClickable: boolean,
    layerIndex?: number,
  ) {
    return (
      <LayerWhereComponent
        editLayerClicked={editLayerClicked}
        aliases={aliases}
        // @ts-expect-error: TODO: refactor LayerWhereComponent
        layerIndex={layerIndex}
        isNotClickable={isNotClickable}
        layer={this}
      />
    );
  }
}

export default LayerWhere;
